/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import { createNavigation } from 'next-intl/navigation'

import { routing } from '@/i18n/routing'

// Server-safe navigation utilities from next-intl
const { redirect, getPathname } = createNavigation(routing)

// Re-export client navigation with regional URL support.
// usePathname strips the /{lang}-{region} prefix so components get clean paths
// (e.g. /dashboard/admin instead of /en-gb/dashboard/admin).
export { Link, usePathname, useRouter } from '@/i18n/client-navigation'

export { redirect, getPathname }
